import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./RegistrationForm.css"; // or wherever those styles live

// Calculate a linear TOTAL cost: $5 at 10 recipients to $200 at 1000 recipients.
// Then derive the per-recipient rate as total / count.
function calculatePrice(recipientCount) {
  const minCount = 10;
  const maxCount = 1000;
  const totalAtMin = 5; // total cost at 10 recipients
  const totalAtMax = 200; // total cost at 1000 recipients

  // Clamp n so we don't go below 10 or above 1000 for pricing
  const n = Math.max(minCount, Math.min(maxCount, recipientCount));

  // slope from T=5 at n=10 to T=200 at n=1000
  const slope = (totalAtMax - totalAtMin) / (maxCount - minCount);
  // intercept so that when n=10, T=5
  const intercept = totalAtMin - slope * minCount;

  // total cost
  const totalPriceNum = slope * n + intercept;
  // price per recipient
  const pricePerRecipientNum = totalPriceNum / n;

  return {
    totalPrice: totalPriceNum.toFixed(2),
    pricePerRecipient: pricePerRecipientNum.toFixed(2),
  };
}

export default function Pricing() {
  // Start at 10 recipients
  const [recipientCount, setRecipientCount] = useState(10);
  const { totalPrice, pricePerRecipient } = calculatePrice(recipientCount);

  const navigate = useNavigate();

  return (
    // REUSE THE SAME STRUCTURE AS "TryIt" 
    <div className="registration-form-container">
      <div className="registration-form">
        <h1 className="pricing-title">Pricing</h1>
        <p>
          Use the slider to select how many responses you’d like to receive and analyze.
          Pricing adjusts automatically based on the number of responses.
        </p>

        {/* Slider + label */}
        <div style={{ margin: "20px 0" }}>
          <input
            type="range"
            min="10"
            max="1000"
            value={recipientCount}
            onChange={(e) => setRecipientCount(Number(e.target.value))}
            style={{ width: "100%" }}
            className="pricing-range"
          />
          <p>
            Responses: <strong>{recipientCount}</strong>
          </p>
        </div>

        <p>
          Price per response: <strong>${pricePerRecipient}</strong>
          <br />
          Total estimated price: <strong>${totalPrice}</strong>
        </p>

        <hr style={{ margin: "40px 0" }} />

        <p style={{ fontSize: "1.1rem" }}>
          <em>Secure payments with Stripe</em>
        </p>

        {/* Button at bottom => navigate to /register */}
        <div style={{ marginTop: "2rem", textAlign: "center" }}>
          <button
            className="submit-btn"
            onClick={() => navigate("/register")}
          >
            Register Now
          </button>
        </div>
      </div>
    </div>
  );
}
